import {Routes} from '@angular/router';
import {PendingChangesGuard} from "app/shared/guards/pending-changes.guard";

export const DAMAGE_REPORTS_BASE_ROUTE = 'feature-machine-damage-reporting';
export const DAMAGE_REPORTS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/damage-report-list/damage-reports.page.component')
  },
  {
    path: 'new',
    loadComponent: () => import('./features/damage-report-create/damage-report-new-page.component'),
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'details/:id',
    loadComponent: () => import('./features/damage-report-show/damage-report-details.page.component')
  }
];
